import FloatingSignUp from "./FloatingSignUp";

export default FloatingSignUp;
